var $ = require("jquery");
var _endsWith = require("lodash/endsWith");
var _find = require("lodash/find");
var Dialog = require("./dialog");

$(document).ready(function () {

    var $exitDialog = $("#exit-dialog");
    var $exitLinkItem = $(".ws-exit-link__item");
    var $exitDialogTarget = $("#exit-dialog-target");
    var allowedDomains = $exitDialog.data("whitelist") || "";

    // Start: Expose allowedDomains for Google analytics
    if (!window.WSFG) {
        window.WSFG = {};
    }

    window.WSFG.ExitAlertWhitelist = allowedDomains.slice();
    // End: Expose allowedDomains...

    $(document).on("click", ".ws-exit-link__item, .ws-exit-dialog__close", function (event) {
        Dialog.closeDialog(event);
    });

    $(document).on("click", "a[href^='http']:not(.ws-exit-link__item):not([data-ws-dialog-content])", function (event) {
        var $target = $(event.currentTarget);
        var href = $target.attr("href");
        var hrefDomain = getDomain(href);

        if (hrefDomain === "") {
            return;
        }

        $(this).focus();

        var allowedDomain = _find(allowedDomains, function (domain) {
            domain = domain.toLowerCase();
            return hrefDomain === domain || _endsWith(hrefDomain, "." + domain);
        });

        if (allowedDomain === undefined) {
            event.preventDefault();
            event.stopPropagation();
            $exitLinkItem.attr("href", href);
            $exitDialogTarget.html(href);

            // this forces the link state to take effect, which would not always happen on external link clicks in android and ios
            setTimeout(function () {
                Dialog.openDialog($exitDialog, event);
            }, 10);
        }
    });
});

function getDomain(url) {
    var hostname;

    //find & remove protocol (http, ftp, etc.) and get hostname
    if (url.indexOf("://") === -1) {
        return "";
    }

    hostname = url.split("/")[2];

    //find & remove port number
    hostname = hostname.split(":")[0];

    //find & remove query string
    hostname = hostname.split("?")[0];

    return hostname.toLowerCase();
}